import axios from '@/libs/http'
import {handlePromise} from "@/libs/util";
import COS from 'cos-js-sdk-v5'
// 腾讯cos上传
// 初始化实例
let cos = new COS({
    getAuthorization: function (option, callback) {
        // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
        // 异步获取临时密钥
        // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
        // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
        // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
        handlePromise(getAuthorization(), (data) => {
            callback({
                TmpSecretId: data.resp.credentials.tmpSecretId,
                TmpSecretKey: data.resp.credentials.tmpSecretKey,
                SecurityToken: data.resp.credentials.sessionToken,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: data.resp.startTime, // 时间戳，单位秒，如：1580000000
                ExpiredTime: data.resp.expiredTime, // 时间戳，单位秒，如：1580000000
            });
        })

    }
})

/**
 * 获取临时密钥
 */
function getAuthorization() {
    return axios.request({
        url: '/s/cos/getAuthorization',
        method: 'get'
    })
}

//生成从minNum到maxNum的随机数
function randomNum(minNum,maxNum){
    switch(arguments.length){
        case 1:
            return parseInt(Math.random()*minNum+1,10);
        case 2:
            return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
        default:
            return 0;
    }
}

const randomStr = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
function getRandomKey(shopId,dir,ext){
    let key = shopId;
    if(!dir.startsWith('/')){
        key +='/';
    }
    key += dir;
    if(key.charAt(key.length -1) !== '/'){
        key += '/';
    }
    key += new Date().getTime()
    for(let i=0;i<10;i++){
        key += randomStr.charAt(randomNum(0,randomStr.length-1))
    }
    if(ext){
        if(key.indexOf('.') === -1){
            key += '.'
        }
        key += ext
    }
    return key;
}
// 存储桶名称
const bucket = "duopei-1305121976"
// 存储桶 region
const region = "ap-guangzhou"

export const uploadFile = (shopId,dir,file)=>{
    let filename = file.name
    let ext = filename.substring(filename.lastIndexOf(".")+1)
    let key = getRandomKey(shopId,dir,ext)
    return new Promise((resolve,reject)=>{
        cos.uploadFile({
            Bucket: bucket, /* 填写自己的 bucket，必须字段 */
            Region: region,     /* 存储桶所在地域，必须字段 */
            Key: key,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
            Body: file, // 上传文件对象
            SliceSize: 1024 * 1024 * 30,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
            onProgress: function(progressData) {
                console.log(JSON.stringify(progressData));
            }
        }, function(err, data) {
            if (err) {
                reject(err);
                console.log('上传失败', err);
            } else {
                resolve("https://cos.duopei.top/"+key);
                console.log('上传成功');
            }
        });
    })
}
